<div class="wrapper" [style.height]="size" [style.width]="size" [class.border]="!isNoImage">
	<img *ngIf="image" [src]="image" />
	<fa-icon *ngIf="isNoImage" [icon]="['fas', 'user-circle']" [style.font-size]="size" [fixedWidth]="false"></fa-icon>
</div>
